import styled from 'styled-components'

export const Box = styled.div`
  padding: 28px 36px 28px;
`
